import { useTranslation } from 'react-i18next';
import { Icon, Button } from '@hotjar/hotsauce';
import { Container, Title, Text, Content, Action, IconContainer } from './common';

export interface HeatmapGenerationErrorProps {
  shouldOpenManualRetaker?: boolean;
  onRetry: () => void;
}

export const HeatmapGenerationError = ({
  shouldOpenManualRetaker,
  onRetry,
}: HeatmapGenerationErrorProps): JSX.Element => {
  const { t } = useTranslation('heatmaps');

  return (
    <Container>
      <Content>
        <IconContainer>
          <Icon icon="warning_alt" size="l" color="text_disabled" />
        </IconContainer>
        <Title>{t('error-states.generation-error.title')}</Title>
        <Action>
          <Text as="p" textType="caption" color="text_light">
            {t(
              `error-states.generation-error.${
                shouldOpenManualRetaker === true ? 'subtitle-open-manual-retaker' : 'subtitle'
              }`,
            )}
          </Text>
        </Action>
        <Action hasExtraPadding>
          <Button kind="secondary" onClick={onRetry}>
            {t(
              `error-states.generation-error.${
                shouldOpenManualRetaker === true ? 'action-retaker' : 'action'
              }`,
            )}
          </Button>
        </Action>
      </Content>
    </Container>
  );
};
